const en = {
    language: "en",
    startseite: {
        ueberschrift: "Welcome to the PubKon+",
        paragraph1: "The PubKon+ is an extension of the AUTEC configurator. With just a few clicks, your customers can make a configuration from A to Z all by themselves.",
        paragraph2: "The PubKon+ can be accessed via your homepage as well as all mobile devices - e.g. directly in your sales room.",
        paragraph3: {
            zeile1: "Have we aroused your interest?",
            zeile2: "Please contact us, we will be happy to advise you."
        },
        paragraph4: {
            labelTelefon: "Phone:",
            valueTelefon: "(+49) 6235 / 9266-0",
            linkTelefon: "+49623592660",
            labelEmail: "Email:",
            valueEmail: "info@autec-wheels.de",
            linkEmail: "info@autec-wheels.de",
            buttonZurAnwendung: "On to application",
            labelButtonZurAnmeldung: "Already registered?",
            buttonZurAnmeldung: "Continue to registration"
        }
    },
    navigation: {
        ueberschrift: "Welcome to the PubKon+",
        sortiment: "Mange product range",
        preise: "Manage prices",
        agb: "Integrate dealer GTC",
        layout: "Adjust layout",
        schnittstellen: "Interfaces",
        einbinden: "Integration"
    },
    loginForm: {
        messageUsername: "Please enter a value at 'Username'!",
        platzhalterUsername: "Username",
        messagePassword: "Please enter a value in 'Password'!",
        platzhalterPassword: "Password",
        buttonLogin: "Login"
    },
    sortiment: {
        panelHeader: {
            fahzeugauswahl: "Vehicle manufacturers",
            radtypauswahl: "AUTEC wheel designs",
            weitere: "Other product groups"
        },
        fahrzeugAuswahl: {
            messageGespeichert: "Product range saved!",
            buttonAlleAbwaehlen: "Deselect all",
            buttonAlleAuswaehlen: "Select all",
            buttonVerwerfen: "Discard changes",
            buttonSpeichern: "Save"
        },
        radtypenAuswahl: {
            messageGespeichert: "",
            buttonAlleAbwaehlen: "Deselect all",
            buttonAlleAuswaehlen: "Select all",
            buttonVerwerfen: "Discard changes",
            buttonSpeichern: "Save"
        },
        produktgruppen: {
            rdks: "TPMS",
            komplettraeder: "Complete wheels",
            messageGespeichert: "Product groups saved!",
            buttonVerwerfen: "Discard changes",
            buttonSpeichern: "Save"
        }
    },
    preise: {
        tabs: {
            preise: "Prices",
            umsatzsteuer: "Value added tax"
        },
        preise: {
            messageCodes: {
                ALTERNATIVE_PREISREGEL_UNBEKANNTER_FEHLER: "An unknown error has occurred.",
                ALTERNATIVE_PREISREGEL_ERFOLGREICH_GESPEICHERT: "Calculation saved.",
                ALTERNATIVE_PREISREGEL_NEGATIVE_ABSCHLAEGE_UNZULAESSIG_FEHLER: "Negative discounts are not permitted."
            },
            pflichtangabe: "is mandatory information.",
            columns: {
                groesse: "Size",
                aufschlagProzent: "Surcharge in percent",
                aufschlagEuro: "Surcharge in euros"
            },
            paragraph1: {
                ueberschrift: "The current calculation for the PubKon+ is a guideline from AUTEC GmbH & Co.KG. These are highlighted in gray and can be customised if necessary.",
                ueberschriftNichtGespeichert: "Changes not yet saved."
            },
            paragraph2: {
                ueberschrift: "Calculation",
                ueberschriftRot: "Please consider the additional freight costs in your calculation."
            },
            paragraph3: {
                ueberschrift: "Wheels"
            },
            paragraph4: {
                ueberschrift: "Complete wheels (programme complete wheels)",
                beschreibung: "This is exclusively our predefined complete wheel programme with attractive prices and immediate availability. These are marked as 'Our recommendation' in the webshop. The price for individually assembled complete wheels is made up as follows: Agreed net purchase price for wheels, TPMS and tyres incl. assembly plus tax."
            },
            paragraph5: {
                ueberschrift: "Tyres",
                beschreibung: "The calculation of the tyre prices is only necessary for the use of configuring an individual complete wheel."
            },
            paragraph6: {
                ueberschrift: "TPMS"
            },
            sternchenText: {
                eins: "The surcharges in percent relate to your purchase price.",
                zwei: "Please enter NET surcharges."
            },
            buttons: {
                vorgabenLaden: "Load current AUTEC specifications",
                verwerfen: "Discard changes",
                speichern: "Save"
            }
        },
        umsatzsteuer: {
            keineDaten: "No data",
            messageCodes: {
                UST_ERFOLGREICH_GELOESCHT: "Successfully deleted!",
                UST_ERFOLGREICH_GESPEICHERT: "Successfully saved!",
                UST_UNBEKANNTER_FEHLER: "An unknown error has occured.",
                UST_DATUME_SCHON_VORHANDEN: "There is already an existing record with this date.",
                UST_ALLGEMEINER_FEHLER_SPEICHERN: "Unfortunately, saving was not successful.",
                UST_LOESCHEN_FEHLER: "Unfortunately, saving was not successful."
            },
            columns: {
                steuersatz: "Value added tax",
                gueltigAb: "valid from",
                aktion: "VAT rate campaign"
            },
            popupLoeschen: {
                ueberschrift: "Do you really want to delete this VAT rate?",
                okText: "Delete",
                cancelText: "Cancel"
            },
            erstellen: {
                ueberschriftNeu: "New VAT rate",
                ueberschriftEditieren: "Edit VAT rate",
                form: {
                    steuersatz: "VAT rate in %",
                    gueltigAb: "Valid from"
                }
            },
            buttons: {
                abbrechen: "Cancel",
                speichern: "Save"
            },
            aktuellerSatz: "Current VAT rate"
        }
    },
    agb: {
        messages: {
            speichernErfolgreich: "GTC settings successfully saved!",
            speichernFehlgeschlagen: "Saving of GTC settings failed!"
        },
        alert: {
            message: "A valid GTC configuration is not yet stored in the system"
        },
        paragraph1: {
            ueberschrift: "Here you can integrate your General Terms and Conditions (GTC).",
            radioOptionOne: "Use the following URL to display your GTC in the PubKon+:",
            radioOptionTwo: "Upload your GTC file to display them in the PubKon+."
        },
        paragraph2: {
            uploadError: "File type not allowed",
            dataiLeseError: "Error reading file"
        },
        auswaehlenButton: "Choose GTC file",
        herunterladenButton: "Download current GTC",
        speichernButton: "Save"
    },
    layout: {
        logoUpload: {
            checkbox: "PubKon+ with own logo",
            keinLogo: "No logo has been uploaded yet.",
            vorschauLabel: "Preview of current logo",
            austauschHinweis: "Logo will be updated by saving.",
            unzulaessigerDateityp: "File type not allowed",
            dateilesefehler: "Error reading file",
            neuesLogoAuswaehlen: "Choose new logo",
            logoposition: "Logo position",
            links: "Left",
            mitte: "Center",
            rechts: "Right",
            kopfzeileMitHintergrund: "Header with background colour",
            kopfzeilenfarbe: "Header colour",
            kopfzeilenfarbeErklaerung: "This colour is will be used for header."
        },
        messages: {
            speichernErfolgreich: "Changes successfully accepted.",
            speichernFehlgeschlagen: "There may be an error by saving the changes."
        },
        farbenEingabe: {
            primary: {
                label: "Primary colour",
                erklaerung: "Replaces the areas that are red in the configurator on the AUTEC homepage or gold in the configurator in the AUTEC webshop."
            },
            secondary: {
                label: "Secondary colour",
                erklaerung: "Replaces the green of some buttons."
            },
            text: {
                label: "Text colour",
                erklaerung: "Replaces the text colour in the configurator"
            }
        },
        buttons: {
            standard: "Use standard values",
            reset: "Discard changes",
            speichern: "Save"
        }
    },
    kontaktdaten: {
        messageSpeichernErfolgreich: "Contact settings successfully saved!",
        messageSpeichernFehlgeschlagen: "Saving of contact settings failed!",
        ueberschrift: "Transmission of a saved configuration",
        checkbox: {
            haendlerEmail: 'Send to my e-mail addresses',
            haendlerEmailMitPdf: 'with PDF file attachments',
            haendlerEmailMitCSV: 'with CSV file attachments',
            haendlerSftp: 'Upload to my SFTP server',
            haendlerSftpMitPdf: 'upload PDF file',
            haendlerSftpMitCSV: 'upload CSV file',
            erlaubeKundenEmail: "The customer can have the PubKon+ configuration sent to his e-mail",
            erlaubeKundenPdf: "The customer can download the PubKon+ configuration as a PDF",
            erlaubeSpeichernFuerShokon: "The customer can save the PubKon+ configuration in the webshop (shopping cart)"
        },
        email: {
            ueberschrift: "Send saved configuration to",
            labelMeineEmail: "My e-mail adress"
        },
        smtpSettings: {
            messages: {
                testErfolgreich: "With the given settings, a connection to the SMTP server could be established successfully.",
                testFehlgeschlagen: "A connection to the SMTP server could not be established with the given settings.",
                speichernErfolgreich: "Settings successfully saved!",
                speichernFehlgeschlagen: "Saving settings failed!"
            },
            ueberschrift: "In order to send e-mails, a valid SMTP server configuration must be available. The e-mails are sent to you and your customers via this server.",
            alertKeineGueltigenEinstellungen: "There is no SMTP server configuration or the sender email address is missing. Please configure an SMTP server below so that e-mails with PubKon + configurations can be sent to you and your customers.",
            labels: {
                absenderEmail: "Sender e-mail",
                absenderEmailHinweis: "(With this e-mail adress the configurations will be sent)",
                smtpServer: "SMTP server",
                smtpPort: "SMTP port",
                smtpBenutzer: "SMTP user",
                smtpVerbindungsicherheit: "SMTP connection security",
                smtpPasswortHinweis: "For security reasons, your current password is not displayed. If you do not want to change your password, please leave the following field blank.",
                smtpPasswort: "SMTP password"
            }
        },
        sftpSettings: {
            messages: {
                testErfolgreich: "With the given settings, a connection to the SFTP server could be established successfully.",
                testFehlgeschlagen: "A connection to the SFTP server could not be established with the given settings.",
                speichernErfolgreich: "Settings successfully saved!",
                speichernFehlgeschlagen: "Saving settings failed!",
                UNKNOWN_ERROR: 'An unknown error occurred. Please check your input, try again later or contact us for support if the problem remains.',
                NO_SUCH_DIRECTORY_ERROR: 'The given SFTP path is not a directory.',
                UNSUPPORTED_OPERATION_ERROR: 'The SFTP operation is unsupported.',
                AUTH_ERROR: 'Can not authenticate with the given SFTP credentials. Please check them and try again.',
                MISSING_INFORMATION_ERROR: 'An information in your SFTP settings is missing. Please check your settings and try again.',
                TIMEOUT_ERROR: 'Connection to SFTP Server could not be established. Please check your settings and try again.',
            },
            ueberschrift: "In order for files to be uploaded to your SFTP server, you must have a valid configuration.",
            alertKeineGueltigenEinstellungen: "There is no SFTP server configuration. Please configure an SMTP server below so that PubKon + configurations can be uploaded to your server.",
            labels: {
                sftpServer: 'SFTP server',
                sftpPort: 'SFTP port',
                sftpBenutzer: 'SFTP user',
                sftpPfad: 'SFTP path',
                sftpPasswortHinweis: "For security reasons, your current password is not displayed. If you do not want to change your password, please leave the following field blank.",
                sftpPasswort: "SMTP password"
            }
        },
        buttons: {
            verwerfen: "Discard changes",
            testen: "Test settings",
            speichern: "Save"
        }
    },
    einbinden: {
        downloadFile: {
            noscript: "JavaScript must be activated for the configurator to work."
        },
        stepOne: {
            ueberschrift: "1. Please contact your web developer.",
            paragraph1: "The following code needs to be added in the head tag on your website.",
            paragraph2: "The following code must be added in the body tag on your website at the point where the PubKon+ should appear."
        },
        stepTwo: {
            ueberschrift: "2. Call up the PubKon+ via an external link.",
            preLinkText: "Alternatively, via this link:",
            postLinkText: "you can call up the PubKon+ directly."
        },
        stepThree: {
            ueberschrift: "3. Download the PubKon+ as HTML file.",
            paragraph1: "As a further alternative, you can download the following HTML file. Any device connected to the Internet can use the PubKon+ via browser (we recommend Chrome or Firefox).",
            button: "Download here"
        }
    }
};
export default en;